const labelStyle = {
  fontSize: '10px',
  lineHeight: '1.4',
  letterSpacing: '0.04em',
  color: 'white',
  whiteSpace: 'nowrap',
  position: 'absolute',
  left: '100%',
  top: '50%',
  transform: 'translateY(-50%)',
  marginLeft: '4px',
  pointerEvents: 'none',
};

const dotStyle = {
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  width: '30px',
  height: '30px',
  transform: 'translate(-50%, -50%)',
};

export default function MapPoints({ setCurrentOrt, currentOrt, mapWidth = 355 }) {
  const loc = [
    { id: "Hallstatt",   top: "80%", left: "30%" },
    { id: "BadAussee",   top: "70%", left: "60%" },
    { id: "BadGoisern",  top: "70%", left: "28%" },
    { id: "BadIschl",    top: "60%", left: "30%" },
    { id: "Ebensee",     top: "40%", left: "60%" },
    { id: "Gmunden",     top: "25%", left: "64%" },
    { id: "StadlPaura",  top: "15%", left: "67%" },
  ];

  return (
    <div className="flex justify-center mt-4 w-full">
      <div className="relative" style={{ width: `${mapWidth}px`, overflow: 'visible' }}>
        <img src="IconMuseumOutline.svg" alt="Museum Icon" className="w-full h-auto block opacity-30" />

        {loc.map(({ id, top, left }) => (
          <div
            key={id}
            style={{ ...dotStyle, top, left }}
            onClick={() => setCurrentOrt(id)}
            onTouchStart={() => setCurrentOrt(id)}
          >
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {currentOrt === id && (
                <div className="absolute w-3 h-3 bg-lime-500 rounded-full animate-ping" />
              )}
              <div className="w-2 h-2 bg-lime-500 rounded-full" />
            </div>
            {currentOrt === id && (
              <span style={labelStyle}>{id}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
